export const CART_LOADING = 'CART_LOADING'
export const ITEM_ADDED = 'ITEM_ADDED'
export const ITEM_REMOVED = 'ITEM_REMOVED'
export const CART_ERROR = 'CART_ERROR'
export const CART_OPEN = 'CART_OPEN'
export const CART_CLOSED = 'CART_CLOSED'

export const CART_TOGGLE = 'CART_TOGGLE'
export const CART_ITEM_CHANGE = 'CART_ITEM_CHANGE'
export const CART_TOTAL = 'CART_TOTAL'
export const CART_DETELE_ITEM = 'CART_DETELE_ITEM'
export const ADD_WISHLIST = 'ADD_WISHLIST'



// WEBPACK FOOTER //
// ./src/redux/types/cartTypes.js